import { useEffect, useState } from 'react';

import { useGetXeroInvoicesQuery } from 'apis/xero.api';
import { INVOICES_TABLE_COLUMNS } from 'constants/xero';
import { useOpen } from 'hooks/useOpen';
import { CommonError } from 'interfaces/shared.interface';
import { ErrorModal, LoadingOverlay, Pagination, Table } from 'shared-components';

import InvoicesRow from './InvoicesRow';

const Invoices = () => {
  const [isErrorModalOpen, handleOpenErrorModal, handleCloseErrorModal] = useOpen();

  const { data, isLoading, isFetching, error } = useGetXeroInvoicesQuery();

  const response = data?.result;
  const { error: errorData } = (error as CommonError)?.data || {};

  const [currentPage, setCurrentPage] = useState(1);
  const [maxResultCount, setMaxResultCount] = useState(10);

  const startIndex = (currentPage - 1) * maxResultCount;
  const endIndex = startIndex + maxResultCount;

  const paginatedInvoices = data?.result.slice(startIndex, endIndex);

  const handleSetCurrentPage = (page: number) => {
    setCurrentPage(page);
  };

  const handleSetMaxResultCount = (count: number) => {
    setMaxResultCount(count);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (error) {
      handleOpenErrorModal();
    }
  }, [error, handleOpenErrorModal]);

  return (
    <div data-cy="invoice-line-items">
      <ErrorModal
        isOpen={isErrorModalOpen}
        handleClose={handleCloseErrorModal}
        errorMessage={errorData?.message}
        description={errorData?.details}
      />

      <div className="relative">
        <LoadingOverlay isLoading={isFetching && !!data} />

        <Table
          dataCy="invoices-table"
          columns={INVOICES_TABLE_COLUMNS}
          isTableEmpty={!response?.length}
          isLoading={isLoading}
        >
          {paginatedInvoices?.map((item) => <InvoicesRow key={item.invoiceID} invoicesData={item} />)}
        </Table>

        <Pagination
          totalCount={response?.length}
          handleSetMaxResultCount={handleSetMaxResultCount}
          maxResultCount={maxResultCount}
          handleSetCurrentPage={handleSetCurrentPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};

export default Invoices;
